// Fallback for failures that carry no message of their own: bodiless error
// responses and requests that never reach the server.
export const GENERIC_ERROR = "Something went wrong. Please reload the page and try again.";
